import React from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import TestingAccountFilter from "../../Common/TestingAccountFilter";

export default function UserFilter({ modal, setModal, params, setParams }) {
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setParams((prevParams) => ({
      ...prevParams,
      [name]: value,
      page: 1,
    }));
  };

  const handleApplyFilter = () => {
    setModal(false);
  };

  const handleClearFilters = () => {
    setParams({
      page: 1,
      type: 1,
      search_key: "",
      status: "",
      start_date: "",
      end_date: "",
      user_id: "",
      testing_account_filter: "hide",
    });
    setModal(false);
  };

 

  return (
    <Modal
      className="filter-modal"
      isOpen={modal}
      toggle={() => setModal((state) => !state)}
      centered
    >
      <ModalHeader toggle={() => setModal((state) => !state)}>
        Filter Options
      </ModalHeader>
      <ModalBody>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Start-Date</label>
            <input
              type="date"
              className="form-control w-100"
              name="start_date"
              value={params.start_date}
              onChange={handleInputChange}
            />
          </div>
          <div className="col-md-6 form-group">
            <label>End-Date</label>
            <input
              type="date"
              className="form-control w-100"
              name="end_date"
              value={params.end_date}
              onChange={handleInputChange}
              min={params.start_date}
            />
          </div>
          <div className="col-md-6 form-group">
            <label>Status</label>
            <select
              className="form-control"
              name="status"
              value={params.status}
              onChange={handleInputChange}
            >
              <option value="">Select Status</option>
              <option value="1">Active</option>
              <option value="2">Inactive</option>
              <option value="3">Blocked</option>
            </select>
          </div>
          <TestingAccountFilter
            className="col-md-6 form-group"
            value={params.testing_account_filter || "hide"}
            onChange={handleInputChange}
          />
        </div>
      </ModalBody>
      <ModalFooter className="justify-content-center">
        <button className="buttons border-button" onClick={handleClearFilters}>
          <span>Clear Filters</span>
        </button>
        <button
          className="buttons background-button"
          onClick={handleApplyFilter}
        >
          <span>Apply Filter</span>
        </button>
      </ModalFooter>
    </Modal>
  );
}
